export default "/images/vendor/flag-icon-css/flags/4x3/af.svg?0b9773700de5d03d896d2e758c905e65";